import { Components } from '@mui/material';

const muiButtonStyles: Components = {
  MuiButton: {
    styleOverrides: {
      root: {
        fontWeight: 500,
        fontSize: '16px',
        minWidth: '200px',
        maxWidth: '380px',
        padding: '12px 30px',
        maxHeight: '50px',
        borderRadius: '30px',
        textTransform: 'none',
        boxShadow: 'none',

        '&:hover': {
          opacity: 0.9,
          boxShadow: 'none'
        },
        '@media (max-width: 1715px)': {
          fontSize: '13px',
          maxHeight: '42px'
        }
        // '&:disabled': {
        //   backgroundColor: '#0F5DB2',
        //   opacity: 0.5,
        //   color: 'white'
        // }
      }
    },
    variants: [
      {
        props: { variant: 'contained', color: 'primary' },
        style: {
          backgroundColor: 'var(--primary)',
          color: 'var(--white)'
          // '&:hover': {
          //   opacity: 0.9
          // }
        }
      },
      {
        props: { variant: 'contained', color: 'secondary' },
        style: {
          backgroundColor: 'purple',
          color: 'white'
          // '&:hover': {
          //   backgroundColor: 'darkpurple'
          // }
        }
      },
      {
        props: { variant: 'outlined' },
        style: {
          borderColor: 'var(--dark-2)',
          color: 'var(--dark-2)'
          // '&:hover': {
          //   opacity: 0.9
          // }
        }
      }
    ]
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: '100%',
        width: '50px',
        height: '50px',
        '@media (max-width: 1715px)': {
          maxHeight: '42px',
          maxWidth: '42px'
        }
      }
    },
    variants: [
      {
        props: { className: 'icon-bordered-square' },
        style: {
          width: '50px',
          height: '50px',
          border: '1px solid var(--gray-6)',
          backgroundColor: 'var(--gray-11)',
          borderRadius: '12px',
          padding: 10,
          '& > svg': {
            width: '30px',
            height: '30px',
            '@media (max-width: 1715px)': {
              width: '20px',
              height: '20px'
            }
          }
        }
      },
      {
        props: { className: 'icon-bordered' },
        style: {
          width: '50px',
          height: '50px',
          border: '1px solid var(--gray-6)',
          backgroundColor: 'var(--gray-11)',
          borderRadius: '100%',
          padding: 20
        }
      },
      {
        props: { className: 'active-icon-bordered' },
        style: {
          width: '50px',
          height: '50px',
          border: '1px solid var(--primary-800)',
          borderRadius: '100%',
          padding: 20,
          backgroundColor: 'var(--primary-50)',
          '& svg path': {
            fill: 'var(--primary-800)'
          }
        }
      },
      {
        props: { className: 'active-icon' },
        style: {
          width: '40px',
          height: '40px',
          border: '1px solid var(--primary)',
          borderRadius: '100%',
          padding: 20,
          backgroundColor: 'var(--primary)',
          '&:hover': {
            backgroundColor: 'var(--primary-600)',
            borderColor: 'var(--primary-50)'
          }
        }
      },
      {
        props: { className: 'no-hover' },
        style: {
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }
      }
    ]
  }
};

export default muiButtonStyles;
